import { TtfFont } from './TtfFont';
import { Resource } from './Resource';

export class TtfFontResource extends Resource<TtfFont> {
  static readonly TypeId: string = 'ttf';

  constructor(id: string) {
    super(id);
  }

  get typeId(): string {
    return TtfFontResource.TypeId;
  }
}
